import React from 'react';
import { Link } from 'react-router-dom';
import { Shell } from '../ui/Layout';
import { Placeholder } from '../ui/Placeholder';
import { blockRecord, blockValue } from '../../data/contentPages';
import { legalDocuments } from '../../data/legal';
import { services } from '../../data/services';
import { industries } from '../../data/industries';
const columns = [{
  heading: 'Executive Search',
  links: services.slice(0, 6).map(s => ({
    label: s.name,
    to: `/services/${s.slug}`
  }))
}, {
  heading: 'Industries',
  links: industries.slice(0, 6).map(i => ({
    label: i.name,
    to: `/industries/${i.slug}`
  }))
}, {
  heading: 'Platform',
  links: [{
    label: 'Leadership Opportunities',
    to: '/opportunities'
  }, {
    label: 'For Candidates',
    to: '/for-candidates'
  }, {
    label: 'For Employers',
    to: '/for-employers'
  }, {
    label: 'Executive Career Services',
    to: '/career-services'
  }, {
    label: 'Insights',
    to: '/insights'
  }, {
    label: 'Contact',
    to: '/contact'
  }]
}];
export function SiteFooter() {
  const email = blockRecord('footer', 'footer.email');
  const hours = blockRecord('footer', 'footer.hours');
  return <footer className="on-dark bg-ink pt-16" data-id="element-456" data-mp="252m91xih7d5r">
      <Shell data-id="element-457" data-mp="252vztnbchoci">
        <div className="grid gap-12 border-b border-navy-600 pb-12 lg:grid-cols-[1.1fr_2fr]" data-id="element-458" data-mp="2534fto2rl9rx">
          <div data-id="element-459" data-mp="2a0o0p6tywksu">
            <div className="flex items-baseline gap-2 font-serif text-parchment" data-id="element-460" data-mp="29z383mr7rbxm">
              <span className="text-[1.0625rem] uppercase tracking-[0.14em]" data-id="element-461" data-mp="1cfi9i825jr1d">Velnoris</span>
              <span aria-hidden="true" className="text-gold" data-id="element-462" data-mp="1hda3r8q9rp8q">|</span>
              <span className="text-[0.8125rem] uppercase tracking-[0.14em] text-navy-100" data-id="element-463" data-mp="1mbldljgkdzqy">Executive Network</span>
            </div>
            <p className="mt-5 max-w-sm font-serif text-[0.9375rem] leading-relaxed text-navy-100" data-id="element-464" data-mp="1r3w9mb86p1e8">
              {blockValue('footer', 'footer.positioning')}
            </p>
            <div className="mt-6 space-y-2 font-sans text-[0.8125rem] text-navy-100" data-id="element-465" data-mp="yl8x3k796uor">
              <p data-id="element-466" data-mp="qkt24w05o5xi">
                <span className="text-navy-200" data-id="element-467" data-mp="qk9ty70b4vwo">Email · </span>
                <a href={`mailto:${email?.value}`} className="text-parchment underline underline-offset-2 transition-colors duration-120 hover:text-gold-200" data-id="element-468" data-mp="ln1c67j2mtvy">
                  {email?.value}
                </a>
              </p>
              <p data-id="element-469" data-mp="7mqkj29xtb9q">
                <span className="text-navy-200" data-id="element-470" data-mp="7m6zvdswk8s0">Hours · </span>
                <Placeholder inline onDark note={hours?.placeholderNote} data-id="element-471" data-mp="7ot9rk39n0de">
                  {hours?.value}
                </Placeholder>
              </p>
            </div>
          </div>

          <div className="grid gap-10 sm:grid-cols-3" data-id="element-472" data-mp="hm7q7jp6vp5p">
            {columns.map(col => <nav key={col.heading} aria-label={col.heading} data-id="element-473" data-mp="ckiavruxopbt">
                <h2 className="font-sans text-micro uppercase tracking-[0.14em] text-navy-200" data-id="element-474" data-mp="1sza3o5vzryln">{col.heading}</h2>
                <ul className="mt-4 space-y-2.5" data-id="element-475" data-mp="1nzxa72am7ta3">
                  {col.links.map(l => <li key={l.to} data-id="element-476" data-mp="1vjg6ubcs7l15">
                      <Link to={l.to} className="font-serif text-[0.9375rem] leading-snug text-navy-100 transition-colors duration-120 hover:text-gold-200" data-id="element-477" data-mp="1vmkjlx4bbp3f">
                        {l.label}
                      </Link>
                    </li>)}
                </ul>
              </nav>)}
          </div>
        </div>

        <div className="space-y-4 border-b border-navy-600 py-10" data-id="element-478" data-mp="2ja2g25yivbcq">
          <p className="max-w-4xl font-sans text-[0.8125rem] leading-relaxed text-navy-200" data-id="element-479" data-mp="2j9ajosx3p9le">
            {blockValue('footer', 'footer.disclaimer')}
          </p>
          <p className="max-w-4xl font-sans text-[0.8125rem] leading-relaxed text-gold-200" data-id="element-480" data-mp="29jh6xol82ofk">
            {blockValue('footer', 'footer.fraud')}
          </p>
        </div>

        <div className="flex flex-col gap-4 py-8 md:flex-row md:items-center md:justify-between" data-id="element-481" data-mp="320jud5ily4ek">
          <nav aria-label="Legal" data-id="element-482" data-mp="1ec8jl3x7w9zo">
            <ul className="flex flex-wrap gap-x-5 gap-y-2" data-id="element-483" data-mp="1ed9th52hyqft">
              {legalDocuments.map(d => <li key={d.slug} data-id="element-484" data-mp="19cdrwy5mbgdk">
                  <Link to={`/legal/${d.slug}`} className="font-sans text-[0.75rem] text-navy-200 transition-colors duration-120 hover:text-parchment" data-id="element-485" data-mp="19f8dwu4a5993">
                    {d.title}
                  </Link>
                </li>)}
            </ul>
          </nav>
          <p className="font-sans text-[0.75rem] text-navy-300" data-id="element-486" data-mp="1s34xrpqecon7">
            © {new Date().getFullYear()} Velnoris Executive Network. All rights reserved.
          </p>
        </div>
      </Shell>
    </footer>;
}